<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
    beforeCreate() {
        const siteId = this.$route.params.siteId;
        localStorage.setItem("siteId", siteId);

        const special = this.$route.query.special;
        if (special === "true") {
            document.body.classList.add("special-background");
        }
        const docSup = this.$route.query.docSup;
        if (docSup === "true") {
            document.body.classList.add("doc-sup");
        }
    }
};
</script>

<style>
body {
    background: #f3f3fe;
}

body.special-background {
    background: transparent !important;
    overflow: hidden;
}

body.doc-sup {
    background: transparent !important;
    overflow: hidden;
}

#app {
    font-family: "Google Sans", Roboto, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>